import React from 'react';
import { useHistory } from 'react-router-dom';
import authService from '../../services/authService';
import Icon from '../common/Icon';
import './Header.css';

const Header = () => {
    const user = authService.getUser();
    const history = useHistory();

    const handleLogout = () => {
        authService.logout();
    };

    return (
        <header className="header">
            <div className="header-content">
                <div className="header-logo">
                    <a href="/" className="header-home-icon" title="Accueil">
                        <Icon name="Home" size={24} color="currentColor" />
                    </a>
                </div>
                <div className="header-actions">
                    {user && (
                        <>
                            <div className="header-user">
                                <span className="header-user-name">{user.name}</span>
                                <span className="header-user-role">{user.role === 'SuperAdmin' ? 'SuperAdmin' : user.role === 'Admin' ? 'Admin' : 'Utilisateur'}</span>
                                <Icon name="User" size={20} color="currentColor" />
                            </div>
                            {(user.role === 'Admin' || user.role === 'SuperAdmin') && (
                                <button
                                    onClick={() => history.push('/admin/users')}
                                    className="header-button admin-button"
                                    aria-label="Administration"
                                    title="Gestion des utilisateurs"
                                >
                                    <Icon name="Settings" size={20} color="currentColor" />
                                </button>
                            )}
                            <button
                                onClick={handleLogout}
                                className="header-button header-logout"
                                aria-label="Déconnexion"
                                title="Déconnexion"
                            >
                                <Icon name="LogOut" size={20} color="currentColor" />
                            </button>
                        </>
                    )}
                </div>
            </div>
        </header>
    );
};

export default Header;
